import http from '../../utils/http';

export default {
    /**
     * 获取学员协议
     *
     * @returns
     */
    getStudentAgreement() {
        return http({
            url: 'BaseSetting/GetStudentAgreement'
        });
    },
    /**
     * 获取课程购买协议
     *
     * @returns
     */
    getBuyAgreement() {
        return http({
            url: 'BaseSetting/GetBuyAgreement'
        });
    },
    /**
     * 关于我们
     *
     * @returns
     */
    getAboutUs() {
        return http({
            url: 'BaseSetting/AboutUs'
        });
    },
    /**
     * 推广合作
     *
     * @returns
     */
    getPromotion() {
        return http({
            url: 'BaseSetting/GetPromotion'
        });
    },
    /**
     * 帮助列表
     *
     * @returns
     */
    getHelpList(data) {
        return http({
            url: 'BaseSetting/HelpList',
            params: data
        });
    },
    /**
     * 帮助详情
     *
     * @param {*} data
     * @returns
     */
    getHelpInfo(data) {
        return http({
            url: 'BaseSetting/HelpInfo',
            params: data
        });
    },
    /**
     * 轮播图
     * 首页轮播图 = 1 专业轮播图 = 2 APP轮播图 = 3
     *
     * @param {*} data
     * @returns
     */
    getBannerList(data) {
        return http({
            url: 'BaseSetting/BannerList',
            params: data,
            headers: {
                showLoading: false
            }
        });
    },
    /**
     * 活动管理
     *
     * @returns
     */
    getActivity() {
        return http({
            url: 'BaseSetting/GetActivity'
        });
    },
    /**
     * 交流分享二维码
     *
     * @returns
     */
    getQRCode() {
        return http({
            url: 'BaseSetting/GetQRCode'
        });
    },
    /**
     * 套餐详情
     *
     * @returns
     */
    getPackageById(data) {
        return http({
            url: 'BaseSetting/GetPackageById',
            params: data
        });
    },
    /**
     * 套餐列表
     *
     * @returns
     */
    getPackageList() {
        return http({
            url: 'BaseSetting/PackageList'
        });
    },
    /**
     * 套餐协议详情
     *
     * @returns
     */
    getPackageAgreementInfo(data) {
        return http({
            url: 'BaseSetting/GetPackageAgreementInfo',
            params: data
        });
    },
    /**
     * 万年历列表
     *
     * @returns
     */
    getCalendarByMonth(data) {
        return http({
            url: 'BaseSetting/CalendarByMonth',
            params: data
        });
    },
    /**
     * 距离考试时间还有多少天
     *
     * @returns
     */
    getCalendarDay(data) {
        return http({
            url: 'BaseSetting/CalendarDay',
            params: data
        });
    }
};
